import { render, staticRenderFns } from "./BookingFooter.vue?vue&type=template&id=ad4dc52a&scoped=true&"
import script from "./BookingFooter.vue?vue&type=script&lang=js&"
export * from "./BookingFooter.vue?vue&type=script&lang=js&"
import style0 from "./BookingFooter.vue?vue&type=style&index=0&id=ad4dc52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4dc52a",
  null
  
)

export default component.exports